export default [
  {
    imgProps: {
      alt: 'AccidentFree',
      src: `${process.env.CVNA_APP_CDN_ASSETS_PATH}/svgs/accident_free.svg`
    },
    title: 'Vehicle history',
    content:
      'Check the vehicle’s auto history report using CarFax® or AutoCheck®, which may include accidents, repairs and maintenance records that the previous owners recorded. This information can give you a better understanding of the car’s condition.'
  },
  {
    imgProps: {
      alt: 'Instrumentation',
      src: `${process.env.CVNA_APP_CDN_ASSETS_PATH}/svgs/instrumentation.svg`
    },
    title: 'Mileage',
    content:
      'Although EVs generally have fewer moving parts than gas-powered cars, mileage still matters. An EV with 100,000 miles might have more battery degradation than one with fewer miles, negatively affecting its range and performance.'
  },
  {
    imgProps: {
      alt: 'InteriorStyling',
      src: `${process.env.CVNA_APP_CDN_ASSETS_PATH}/svgs/interior_styling.svg`
    },
    title: 'Interior and exterior condition',
    content:
      'Check for any signs of damage or wear and tear, both inside and outside the vehicle. A used EV with a well-maintained interior and no signs of exterior damage is more likely to provide a trouble-free ownership experience. Carvana makes it easy to virtually tour the inside and outside of the vehicle.'
  }
];
